import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";  // <- AICI TREBUIE


import { AuthProvider } from "./context/AuthContext"; // 🔥 IMPORTANT

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
